import * as React from 'react';
import { useState, useEffect } from 'react';
import YadoItemPhotoView from './views/YadoItemPhotoView';
import { IYado } from '../types';

interface IProps {
  yado: IYado,
}

const YadoList: React.FC<IProps> = ({ yado }) => {
  const { images } = yado;
  if (images == null || images.length === 0) {
    return (
      <YadoItemPhotoView>
        <div className="photo-container">
          <div className="no-image">No Image</div>
        </div>
      </YadoItemPhotoView>
    );
  }
  return (
    <YadoItemPhotoView>
      <div className="photo-container">
        <div className="photo-big">
          <img src={images[0]} alt="" />
          <div className="photo-cover" />
        </div>
        {/*
          <ul>
            <li>
              <div className="photo-small">
                <img src="img/sample02.jpg" alt="" />
                <div className="photo-cover" />
              </div>
            </li>
            <li>
              <div className="photo-small">
                <img src="img/sample03.jpg" alt="" />
                <div className="photo-cover" />
              </div>
            </li>
            <li>
              <div className="photo-small">
                <img src="img/sample04.jpg" alt="" />
                <div className="photo-cover" />
              </div>
            </li>
            <li>
              <div className="photo-small">
                <img src="img/sample05.jpg" alt="" />
                <div className="photo-cover" />
              </div>
            </li>
            <li>
              <div className="photo-small">
                <img src="img/sample04.jpg" alt="" />
                <div className="photo-cover black_cover">
                  <div className="photo_more"><span>全て</span></div>
                </div>
              </div>
            </li>
          </ul>
          */}
      </div>
    </YadoItemPhotoView>
  );
}

export default YadoList;
